export default "__VITE_ASSET__uigpcEfr__"